import{styled as o}from"@linaria/react";import{ColorRectangle as r}from"./ColorRectangle.js";import"./theme.js";import"./utils-183583ee.js";import"./ColorRectangleModel.js";const e=o(r)({name:"ColorCircle",class:"cffj7me",propsAsIs:!0});export{e as ColorCircle};
//# sourceMappingURL=ColorCircle.js.map
